
var CustomMap = function(options) {
	var self = this;

	this.options = $.extend({
		container: $('#map'),
		zoom: 12,
		backgroundColor: '#ffffff',
		minZoom: 5,
		maxZoom: 17,
		zoomInterval: 1200,
		mapTypeControl: false,
		scrollwheel: false,
		streetViewControl: false
	}, options);

	this.map           = false;
	this.currentCenter = this.options.center;
	this.markers       = [];
	this.markerOptions = {};

	google.maps.event.addDomListener(window, 'load', function() {
		self.init();
	});
};


CustomMap.prototype.init = function() {
	var self = this;

	this.map = new google.maps.Map(this.options.container.get(0), this.options);

	// Keep the map centered while resizing the window
	google.maps.event.addDomListener(window, 'resize', function() {
		setTimeout(function() {
			self.map.setCenter(self.currentCenter);
		}, 100);
	});

	this.map.addListener('dragend', function() {
		self.currentCenter = self.map.getCenter();
	});

	if (typeof this.options.onInit == 'function') {
		this.options.onInit(this);
	}

};

CustomMap.prototype.reload = function() {
	var self = this;

	setTimeout(function() {
		google.maps.event.trigger(self.map, 'resize');
		self.fitBounds();
	}, 100);
};

CustomMap.prototype.loadMarkers = function(markers, options) {
	var self = this;

	this.markerOptions = $.extend({
		image: false,
		onClick: false
	}, options);

	if (this.markerOptions.image != false) {
		var image = new google.maps.MarkerImage(this.markerOptions.image);
	}

	for (var i = 0; i < markers.length; i++) {
		var markerData = markers[i];

		if (markerData.latLng[0] == 0) {
			continue;
		}

		var marker = new google.maps.Marker({
			map: this.map,
			icon: image,
			draggable: false,
			position: new google.maps.LatLng(markerData.latLng[0], markerData.latLng[1]),
			visible: true,
			markerData: markerData
		});

		this.markers.push(marker);

		if (typeof this.markerOptions.onClick == 'function') {
			google.maps.event.addListener(marker, 'click', (function(marker) {
				return function() {
					self.markerOptions.onClick(marker);
				}
				})(marker)
			);
		}
	}
};

CustomMap.prototype.clearMarkers = function() {
	for (var i = 0; i < this.markers.length; i++) {
		this.markers[i].setMap(null);
	}

	this.markers = [];
};

CustomMap.prototype.fitBounds = function() {
	if (this.markers.length == 0) {
		return;
	}

	var bounds = new google.maps.LatLngBounds();

	for (var i = 0; i < this.markers.length; i++) {
	 	bounds.extend(this.markers[i].getPosition());
	}

	this.map.fitBounds(bounds);
};

CustomMap.prototype.initSearchForm = function(formSelector, resultsSelector, searchUrl, onLoad) {
    $(formSelector).on('submit init-searchform', function(e) {
        e.preventDefault();

        var args = $(this).serialize();

		$(resultsSelector).stop(false, false).slideUp('fast', function() {
			var $block = $(this);

			$block.html('');

			$.getJSON('/site/ajax/search_locations.php', args, function (data) {
				var prevId = 0;
				var resultIds = [];
				var count = 1;

				for (var key in data.items) {
					var item     = data.items[key];
					var id       = item.id;
					var $element = $(item.html);

					resultIds.push(id);

					if ($(resultsSelector + ' > div[data-item_id=' + id + ']').length > 0) {
						continue;
					}

					if (prevId == 0) {
						$element.prependTo(resultsSelector);
					} else {
						$element.insertAfter(resultsSelector + ' > div[data-item_id=' + prevId + ']');
					}

					$element.hide();
					prevId = id;

					$element.slideDown();
					count++;
				}

				// $(resultsSelector + ' > div').each(function() {
				// 	var itemId = $(this).attr('data-item_id');

					// if ($.inArray(itemId, resultIds) < 0) {
					// 	$(this).slideUp('fast', function() {
					// 		$(this).remove();
					// 	});
					// }
				// });

				$block.slideDown('fast');

				if (typeof onLoad == 'function') {
					onLoad(data);
				}
			});
		});
    }); //.trigger('init-searchform');
};
